import React, { Component } from 'react';

import urls from "../../utils/urls";
import './styles.scss';

export default class ProfileImage extends Component {

    render() {

        let {user} = this.props;
        let profile = '';
        if(user.profile && user.profile.avatar_url){
            if(user.profile.avatar_url.indexOf('ssoshellargentina') > -1){
                profile = user.profile.avatar_url
            }
            if(user.profile.avatar_url.indexOf('/static') > -1){
                profile = `${urls.API_ROOT}${user.profile.avatar_url}`;
            }
        }

        return (
            <img src={profile} alt={user.first_name} className={'account'} />
        );
    }
}

ProfileImage.defaultProps = {
    user: {first_name: 'Usuario'}
};



// WEBPACK FOOTER //
// ./src/components/profileImage/ProfileImage.js